/** Blocks */

import 'slick-carousel';
import './helper/jquery.nice-select.min.js';
import './helper/fancybox.js';
import './helper/lazyload.js';

import './blocks/video-block';
import './blocks/hero';
import './blocks/faq';
import './blocks/calculator';
import './blocks/trailers-listing';
import './blocks/trailer-top-block';

$ = jQuery;

$(function () {
  // Lazyload
  window.image_lazyload('.lazyload');

  // Nice Select
  $('select').niceSelect();

  $('.prime-fancy').fancybox();

  // Burger Menu
  // const button = document.getElementById('burger');
  // const box = document.getElementById('mobileMenu');

  // button.addEventListener('click', function () {
  //   button.classList.toggle('active');
  //   box.classList.toggle('active');
  // });

  // Header add Class on Scroll
  window.addEventListener('scroll', function () {
    const HeaderElement = document.querySelector('header');
    if (window.scrollY > 100) {
      HeaderElement.classList.add('active');
    } else {
      HeaderElement.classList.remove('active');
    }
  });

  // Single Trailer Custom Form Options
  if (document.getElementById('customFormOptions')) {
    document
      .getElementById('customFormOptions')
      .addEventListener('click', function () {
        this.classList.toggle('active');
        document
          .getElementById('primeCustomTrailerOptions')
          .classList.toggle('active');
      });
  }

  // Burger Menu
  document.getElementById('primeBurger').addEventListener('click', function () {
    this.classList.toggle('active');
    document.getElementById('primeHeaderMobile').classList.toggle('active');
  });

  // Mobile Filter
  document
    .getElementById('mobileFilters')
    .addEventListener('click', function () {
      this.classList.toggle('active');
      document
        .getElementById('primeInventoryFilter')
        .classList.toggle('active');
    });
});
